module.exports = __webpack_public_path__ + "img/call_top.d0a7c531.png";